import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DoneIcon from "@mui/icons-material/Done";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { WORD_STATUS, type WordStatus } from "./types";

export interface EditorFilterProps {
  filter: WordStatus | undefined;
  onChangeFilter: (filter: WordStatus | undefined) => void;
  untranslatedCount: number;
  changedCount: number;
  translatedCount: number;
  query: string;
  onChangeQuery: (query: string) => void;
  onClickDeleteAllUntranslated: () => void;
}

export function EditorFilter({
  filter,
  onChangeFilter,
  untranslatedCount,
  changedCount,
  translatedCount,
  query,
  onChangeQuery,
  onClickDeleteAllUntranslated,
}: EditorFilterProps) {
  const toggle = (value: WordStatus) => {
    onChangeFilter(filter === value ? undefined : value);
  };

  return (
    <List dense>
      <ListItemButton
        onClick={() => toggle(WORD_STATUS.UNTRANSLATED)}
        selected={filter === WORD_STATUS.UNTRANSLATED}
      >
        <ListItemIcon>
          <BlockIcon />
        </ListItemIcon>
        <ListItemText primary="Не переведено" />
        {untranslatedCount > 0 && (
          <Tooltip title="Удалить все непереведённые">
            <IconButton
              size="small"
              color="error"
              onClick={(event) => {
                event.stopPropagation();
                onClickDeleteAllUntranslated();
              }}
            >
              <DeleteSweepIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Typography variant="body2" color="textSecondary" sx={{ ml: 1 }}>
          {untranslatedCount}
        </Typography>
      </ListItemButton>
      <ListItemButton
        onClick={() => toggle(WORD_STATUS.CHANGED)}
        selected={filter === WORD_STATUS.CHANGED}
      >
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        <ListItemText primary="Изменено" />
        <Typography variant="body2" color="textSecondary">
          {changedCount}
        </Typography>
      </ListItemButton>
      <ListItemButton
        onClick={() => toggle(WORD_STATUS.TRANSLATED)}
        selected={filter === WORD_STATUS.TRANSLATED}
      >
        <ListItemIcon>
          <DoneIcon />
        </ListItemIcon>
        <ListItemText primary="Переведено" />
        <Typography variant="body2" color="textSecondary">
          {translatedCount}
        </Typography>
      </ListItemButton>
      <ListItem>
        <TextField
          fullWidth
          type="search"
          placeholder="Поиск по ключу, значению и подсказке"
          value={query}
          onChange={(event) => onChangeQuery(event.target.value)}
        />
      </ListItem>
    </List>
  );
}
